/* ⚛ REACT */
import { useState, useMemo } from "react";

/* 📦 LIBS */
import { ResponsiveLineCanvas } from "@nivo/line";
import { useTranslation } from "react-i18next";

/* 🎨 STYLES */
import {Container, ContainerGraph, NoDataContainer, NoDataText, NumberInput, Text, ButtonsContainer} from "./styles";


const Graph = ({ data, showLegends }) => {
    const { t } = useTranslation();

    const [maximo, setMaximo] = useState('');
    const [minimo, setMinimo] = useState('');
    const colors = data.map((item) => item.color);

    const graphData = useMemo(() => {
        let tempMaximo = 0;
        let tempMinimo = 2000;
        return data.map((item) => {
            item.data = item.data.map((DataItem) => {
                if (DataItem.y < tempMinimo) {
                    tempMinimo = (DataItem.y - DataItem.y * 0.2);
                }
                if (DataItem.y > tempMaximo) {
                    tempMaximo = (DataItem.y + DataItem.y * 0.2);
                }
                DataItem.x = new Date(DataItem.x)
                return DataItem
            })
            setMaximo(parseFloat(tempMaximo).toFixed(2));
            setMinimo(parseFloat(tempMinimo).toFixed(2));
            return item
        })
    }, [data])

    return (
        <Container>
            <ButtonsContainer id="general-data">
                <Text>{t("reports.sub-items.history.general.graph.minimum")}:</Text>
                <NumberInput
                    type="number"
                    value={minimo}
                    onChange={(e) => setMinimo(e.target.value)}
                />
                <Text>{t("reports.sub-items.history.general.graph.maximum")}:</Text>
                <NumberInput
                    type="number"
                    value={maximo}
                    onChange={(e) => setMaximo(e.target.value)}
                />
            </ButtonsContainer>

            {graphData[0].data.length > 0 ? (
                <ContainerGraph>
                    <ResponsiveLineCanvas
                        data={graphData}
                        margin={showLegends ? { top: 25, right: 60, bottom: 70, left: 60 } : { top: 25, right: 60, bottom: 70, left: 60 }}
                        xScale={{ type: 'time', format: '%m-%dT%H:%M:%S' }}
                        yScale={{
                            type: 'linear',
                            min: minimo || minimo === 0 ? minimo : 'auto',
                            max: maximo ? maximo : 'auto',
                            reverse: false
                        }}
                        xFormat="time:%m-%dT%H:%M:%S"
                        axisLeft={{
                            orient: 'left',
                            tickSize: 5,
                            tickPadding: 5,
                            tickRotation: 0,
                            legendPosition: 'middle',
                            format: '.2f'
                        }}
                        axisBottom={{
                            format: '%d/%m - %H:%M',
                            tickValues: 10,
                            tickRotation: 60,
                            legendOffset: -80,
                            truncateTickAt: 3,
                            legendPosition: "start",
                        }}
                        pointSize={2}
                        pointColor={{ theme: 'background' }}
                        pointBorderWidth={2}
                        pointBorderColor={{ from: 'serieColor' }}
                        pointLabelYOffset={-12}
                        useMesh={true}
                        areaBaselineValue={minimo < 0 ? 0 : minimo }
                        enableArea = {!showLegends}
                        areaOpacity={0.25}
                        animate={false}
                        colors= {colors}
                        tooltip={( slice ) => {
                            let day = slice.point.data.x.getDate().toString().length > 1 ? slice.point.data.x.getDate() : '0' + slice.point.data.x.getDate().toString();
                            let month = (slice.point.data.x.getMonth()+1).toString().length > 1 ? (slice.point.data.x.getMonth()+1) : '0' + (slice.point.data.x.getMonth()+1).toString();

                            let Hour = slice.point.data.x.getHours().toString().length > 1 ? slice.point.data.x.getHours() : '0' + slice.point.data.x.getHours().toString();
                            let Minuto = slice.point.data.x.getMinutes().toString().length > 1 ? slice.point.data.x.getMinutes() : '0' + slice.point.data.x.getMinutes().toString();
                            let horario = (day+'/'+month+' - '+Hour +':'+ Minuto)

                            return (
                                <div
                                    style={{
                                        background: 'white',
                                        padding: '9px 12px',
                                        border: '1px solid #ccc',
                                        opacity: 0.8,
                                        width: 'max-content',
                                    }}
                                >
                                    <div style={{color:'#006560'}} ><strong>Horário: </strong>{horario}</div>
                                    <div
                                        key={slice.point.id}
                                        style={{
                                        color: slice.point.serieColor,
                                        padding: '3px 0',
                                        flexWrap: 'wrap',
                                        maxWidth: '150px',
                                        }}
                                    >
                                        <strong style={{color: colors[slice.point.seriesIndex]}}>{slice.point.seriesId}: </strong> {slice.point.data.yFormatted}
                                    </div>
                                </div>
                            )
                        }}
                    /> 
                </ContainerGraph>
            ) : (
                <NoDataContainer>
                    <NoDataText>Sem Dados</NoDataText>
                </NoDataContainer>
            )}
        </Container>
    );
};

export default Graph;
